module.exports = __webpack_public_path__ + "static/media/homemade-04.86efc317.webm";